<script setup lang="ts">
import type { AvatarImageProps } from 'reka-ui';

import { AvatarImage } from 'reka-ui';

interface Props {
	src?: AvatarImageProps['src'];
	alt?: string;
	width?: string | number;
	height?: string | number;
	format?: string;
	loading?: 'lazy' | 'eager';
}

const props = withDefaults(defineProps<Props>(), {
	src: '',
	alt: '',
	width: '128',
	height: '128',
	format: 'webp',
	loading: 'lazy'
});

const img = useImage();

// O AvatarImage do reka-ui baixa o src que recebe (Image interno de
// loading-status) — entregar a URL crua ali custava o upload original
// (retratos de corretor de até 4MB). Processa ANTES e todo mundo — reka e
// <img> — enxerga só a URL do proxy.
const isRawBucketUrl = computed(() => {
	if (!props.src?.startsWith('http')) return false;
	try {
		return /(^|\.)amazonaws\.com$/.test(new URL(props.src).hostname);
	} catch {
		return false;
	}
});

const processedSrc = computed(() => {
	// Só URLs absolutas de bucket precisam do proxy aqui — caminhos relativos
	// (fallbacks) e URLs já processadas passam intactos; processá-los à mão
	// resolvia contra o baseURL de build (localhost no Netlify) e pendurava
	// o load da página.
	if (!props.src || !isRawBucketUrl.value) return props.src;
	try {
		return img(props.src, {
			width: Number(props.width),
			height: Number(props.height),
			format: props.format
		});
	} catch {
		return props.src;
	}
});
</script>

<template>
	<AvatarImage :src="processedSrc" as-child>
		<img
			:src="processedSrc"
			:alt="props.alt"
			:width="props.width"
			:height="props.height"
			:loading="props.loading"
			class="size-full object-cover"
		/>
	</AvatarImage>
</template>
